var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.injections.components.ZenEllipsis,{tag:"component"},[_vm._v(" "+_vm._s(_vm.props.data && _vm.props.data.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }